// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2q-3";
export var dialog = "_2q-0";
export var divClassnameSwatch = "_2q-8";
export var flexSwatch = "_2q-4";
export var header = "_2q-1";
export var styleAttributeSwatch = "_2q-7";
export var swatch = "_2q-2";
export var textHeaderSwatch = "_2q-5";
export var webSwatch = "_2q-6";